module.exports = __webpack_public_path__ + "img/img_10.58a0dcad.png";